import { BarColorMap } from "../data/metric-config";
import { MetricListItem as MetricListItemType } from "./MetricList";

type MetricListItemProps = {
  metric: MetricListItemType;
};

const getBarColorKey = (pr: number) => {
  if (pr < 0.3) {
    return "low";
  } else if (pr > 0.7) {
    return "high";
  }
  return "mid";
};

const MetricListItem = ({ metric }: MetricListItemProps) => {
  const displayValue =
    metric.unit === "%" && metric.value ? metric.value * 100 : metric.value;

  const barColorKey: keyof typeof BarColorMap = getBarColorKey(metric.pr ?? 0);

  return (
    <div className="mb-3 flex items-center text-sm text-gray-500">
      <div className="w-[120px] sm:w-[240px] md:w-[150px] lg:w-[180px]">
        {metric.indicator}
      </div>
      <div className="w-[60px] text-right sm:w-[120px] md:w-[60px]">
        {displayValue?.toFixed(2) ?? "-"}
        {metric.unit}
      </div>
      <div className="ml-8 max-w-[160px] flex-1 pr-4">
        <div className="h-3 w-full overflow-hidden rounded bg-gray-200">
          <div
            className="h-full rounded"
            style={{
              width: `${metric.pr ? metric.pr * 100 : 0}%`,
              background: BarColorMap[barColorKey],
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default MetricListItem;
